import React from "react";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import ProfileCard from "../common/profileCard";
import StudentSidebar from "../common/studentSidebar";
import LiveClassDashboard from "../common/liveClassDashboard";
import { useTranslation } from "react-i18next";

const StudentLiveClasses = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="content">
        <div className="container">
          {/* Profile Box */}
          <ProfileCard />
          <div className="row">
            {/* Sidebar */}
            <StudentSidebar />
            {/* Main Content */}
            <div className="col-lg-9">
              <Breadcrumb title={t("liveClasses.title")} />
              {/* Live Class Dashboard */}
              <LiveClassDashboard maxItems={5} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentLiveClasses;
